import styled from 'styled-components';
import { colors } from '../../globalStyles';

export const FlexDiv = styled.div({ display: 'flex' });

export const FlexCol = styled.div({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  borderRadius: '5px',
  margin: '0px 20px',
  width: '450px',
  height: '100%',
  '@media only screen and (max-width: 1025px)': {
    margin: '0 auto',
  },
});

export const FlexRow = styled.div({
  display: 'flex',
  justifyContent: 'center',
  padding: '10px',
});

export const FlexWrappedRow = styled(FlexRow as any)({
  flexWrap: 'wrap',
});

export const FlexStart = styled.div({
  display: 'flex',
  width: '100%',
  justifyContent: 'flex-start',
});

export const SpaceBetween = styled.div({
  display: 'flex',
  width: '100%',
  justifyContent: 'space-between',
  alignItems: 'baseline',
});

export const Center = styled.div({
  display: 'flex',
  width: '100%',
  justifyContent: 'center',
});

export const CenterJustified = styled(Center as any)({
  marginBottom: '20px',
  marginTop: '10px',
});

export const SwipeRow = styled.div({
  display: 'flex',
  justifyContent: 'space-around',
  alignItems: 'center',
  padding: '0',
  width: '100%',
  overflow: 'hidden',
});

export const HeaderDiv = styled.div({
  display: 'flex',
  alignItems: 'center',
  backgroundColor: 'transparent',
  borderBottom: `1px solid ${colors.border}`,
  height: '50px',
  justifyContent: 'space-between',
  position: 'relative',
});

export const FlexBaseLine = styled.div({
  display: 'flex',
  width: '100%',
  justifyContent: 'flex-start',
  alignItems: 'baseline',
});
